import { render } from "./DynamicList.vue?vue&type=template&id=a57d046e&scoped=true&ts=true"
import script from "./DynamicList.vue?vue&type=script&lang=ts"
export * from "./DynamicList.vue?vue&type=script&lang=ts"

import "./DynamicList.vue?vue&type=style&index=0&id=a57d046e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a57d046e"]])

export default __exports__